<template>
  <div class="form-group">
    <label
      :for="`extra-${extraId}-${offerLineId}`"
    >
      {{ $n(offerLine.totalPricePerUnit, 'currency', languageCode) }} per {{ offerLine.name }}
      <span v-if="offerLine.pricePerUnit != offerLine.totalPricePerUnit">
        was ({{ $n(offerLine.pricePerUnit, 'currency', languageCode) }})
      </span>
    </label>
    <div class="input-wrapper">
      <select
        :id="`extra-${extraId}-${offerLineId}`"
        v-model="quantity"
        :disabled="disabled"
        class="form-control"
      >
        <option>0</option>
        <option
          v-for="n in offerLine.maxQuantity"
          :key="n"
        >
          {{ n }}
        </option>
      </select>
      <i class="icon--arrow-dropdown float-right input-icon" />
    </div>
  </div>
</template>

<script>
export default {
    name: 'OfferLineOption',
    props: {
        extraId: {
            type: Number,
            default: null
        },
        offerLineId: {
            type: Number,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        offerLine: {
            get () {
                return this.$store.state.extra
                    .extras.find(e => e.id === this.extraId)
                    .offerLines.find(o => o.id === this.offerLineId)
            }
        },
        quantity: {
            get () {
                return this.offerLine.quantity
            },
            set (value) {
                this.$store.commit('updateExtraBySummary', {
                    extraId: this.extraId,
                    offerLineId: this.offerLineId,
                    quantity: parseInt(value)
                })
            }
        },
        languageCode () {
            var code = this.$store.getters['getLanguageCode']({
                identifier: this.$store.state.airport.selectedAirportId
            })
            if (code !== null) {
                return code
            }
            return 'en-GB'
        }
    }
}
</script>
